import { useEffect, useState } from "react";
import { ColumnItem } from "../../common/models/table";
import { useQueryStorageLoadState } from "./core/_hooks";
import { useStorageDetailHistoryStore } from "./store/StorageDetailHistoryStore";
import { StorageService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../common/components/Loader/Loader";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";

type PropsType = {
  initialState: any;
};

export const StorageHistoryDetail = ({ initialState }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { data: storageLoadState, isLoading: storageLoadStateLoader } =
    useQueryStorageLoadState();

  const { list, pageState, resetPageState, setPageState, totalItems, setList } =
    useStorageDetailHistoryStore();

  const cols: ColumnItem[] = [
    {
      key: "operationLoad",
      title: "Marchandises",
      dataIndex: "operationLoad",
      show: true,
      searchType: "text",
      searchKey: "operationLoad.storageLoads.uniqueIdentifierLoad",

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.uniqueIdentifier}</span>
          </div>
        );
      },
    },
    {
      key: "state",
      title: "Type de mouvement",
      dataIndex: "state",
      show: true,
      searchType: "select",
      searchKey: "state",
      nestedKey: "state",
      isLoading: storageLoadStateLoader,
      searchOptions: storageLoadState,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "tonnage",
      title: "Tonnage (T)",
      dataIndex: "tonnage",
      show: true,
    },
    {
      key: "createdAt",
      title: "Date",
      dataIndex: "createdAt",
      show: true,
    },
  ];

  useEffect(() => {
    fetchAllStorageDetailHistory({
      ...pageState,
      storage: initialState?.id,
    });
  }, [pageState, initialState]);

  const fetchAllStorageDetailHistory = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await StorageService.getStorageDetailHistoryList({
        ...params,
      });
      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div>
      <Loader isLoading={isLoading} />

      <div className="mt-4">
        <LFTableV3
          columns={cols}
          data={list}
          params={pageState}
          onAction={() => {}}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={handleSetParams}
        />
      </div>
    </div>
  );
};
